import { FC } from 'react';

import { ReportType } from 'app/services/edpApiV1/reports';
import FormRecord from '../form-record';

const ReportReferences: FC = () => <FormRecord type={ReportType.Vacation} />;

export default ReportReferences;
